"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));
var _isBoolean2 = _interopRequireDefault(require("lodash/isBoolean"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Avatar = _interopRequireDefault(require("../Avatar"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _ClientCardSkeleton = _interopRequireDefault(require("../ClientCardSkeleton"));
var _CreateTicketButton = _interopRequireDefault(require("../../Tickets/CreateTicketButton"));
var _EditableField = _interopRequireDefault(require("../../Common/EditableField"));
var _Messenger = _interopRequireDefault(require("../../Chains/Messenger"));
var _Name = _interopRequireDefault(require("../Name"));
var _iconsReact = require("../../../../icons-react");
var _excluded = ["active", "avatarUrl", "email", "errors", "id", "isDeleted", "isLoading", "isNew", "isPartnerClient", "messengers", "name", "ticketable"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
  TODO: // Переписать компонент на TypeScript
  @see https://leveltravel.atlassian.net/browse/LT-23506
*/
var MessengerTypes = _Messenger["default"].Types;
var StyledInput = _EditableField["default"].StyledInput,
  StyledPlaceholder = _EditableField["default"].StyledPlaceholder,
  StyledValue = _EditableField["default"].StyledValue;
var VALIDATION_PATTERNS = {
  CYRILLIC: /^[\u0400-\u04FF]*$/g,
  NUMBERS: /^[0-9]*$/g,
  EMAIL: /\S+@\S+\.\S+/
};
var VALIDATION_RULES = {
  NAME: {
    error: 'Только кириллица',
    pattern: VALIDATION_PATTERNS.CYRILLIC
  },
  SURNAME: {
    error: 'Только кириллица',
    pattern: VALIDATION_PATTERNS.CYRILLIC
  },
  PHONE: {
    error: 'Только цифры',
    pattern: VALIDATION_PATTERNS.NUMBERS
  },
  EMAIL: {
    pattern: VALIDATION_PATTERNS.EMAIL
  }
};
var ClientCard = /*#__PURE__*/function (_React$PureComponent) {
  function ClientCard(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ClientCard);
    _this = _callSuper(this, ClientCard, [props]);
    var isForceEditable = props.forceEditable;
    _this.state = {
      email: (0, _get2["default"])(props, 'email'),
      isEmailEditable: (0, _isBoolean2["default"])(isForceEditable) ? isForceEditable : true,
      isNameEditable: (0, _isBoolean2["default"])(isForceEditable) ? isForceEditable : !props.name,
      isPhoneEditable: (0, _isBoolean2["default"])(isForceEditable) ? isForceEditable : !props.phone,
      isSurnameEditable: (0, _isBoolean2["default"])(isForceEditable) ? isForceEditable : !props.surname,
      name: (0, _get2["default"])(props, 'name'),
      phone: (0, _get2["default"])(props, 'phone'),
      showErrors: false,
      surname: (0, _get2["default"])(props, 'surname')
    };
    _this.handleCallClick = _this.handleCallClick.bind(_this);
    _this.handleChangeField = _this.handleChangeField.bind(_this);
    _this.handleFocusField = _this.handleFocusField.bind(_this);
    _this.handleSaveField = _this.handleSaveField.bind(_this);
    _this.handleResetField = _this.handleResetField.bind(_this);
    _this.phoneFieldRenderer = _this.phoneFieldRenderer.bind(_this);
    _this.handleNewTicketClick = _this.handleNewTicketClick.bind(_this);
    _this.handleSave = _this.handleSave.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(ClientCard, _React$PureComponent);
  return (0, _createClass2["default"])(ClientCard, [{
    key: "handleCallClick",
    value: function handleCallClick() {
      var value = this.state.phone;
      var onCallClick = this.props.onCallClick;
      onCallClick({
        value: value
      });
    }
  }, {
    key: "handleMessengerClick",
    value: function handleMessengerClick(_ref) {
      var type = _ref.type,
        value = _ref.value;
      var onMessengerClick = this.props.onMessengerClick;
      onMessengerClick({
        type: type,
        value: value
      });
    }
  }, {
    key: "handleChangeField",
    value: function handleChangeField(_ref2) {
      var target = _ref2.target;
      var name = target.name,
        value = target.value;
      this.setState((0, _defineProperty2["default"])({}, name, value));
    }
  }, {
    key: "handleFocusField",
    value: function handleFocusField() {
      var onFocusField = this.props.onFocusField;
      this.setState({
        showErrors: false
      }, onFocusField);
    }
  }, {
    key: "handleSaveField",
    value: function handleSaveField(_ref3) {
      var name = _ref3.name,
        value = _ref3.value;
      var isNew = this.props.isNew;
      this.setState((0, _defineProperty2["default"])({}, name, value), !isNew ? this.handleSave() : null);
    }
  }, {
    key: "handleResetField",
    value: function handleResetField(_ref4) {
      var name = _ref4.name;
      var oldValue = (0, _get2["default"])(this.props, name);
      this.setState((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, name, oldValue), "showErrors", false));
    }
  }, {
    key: "handleNewTicketClick",
    value: function handleNewTicketClick() {
      var _this$props = this.props,
        clientId = _this$props.id,
        onNewTicketClick = _this$props.onNewTicketClick;
      onNewTicketClick({
        clientId: clientId
      });
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      var _this$props2 = this.props,
        id = _this$props2.id,
        onSave = _this$props2.onSave;
      var _this$state = this.state,
        name = _this$state.name,
        surname = _this$state.surname,
        phone = _this$state.phone,
        email = _this$state.email;
      var savingParams = (0, _pickBy2["default"])({
        id: id,
        name: name,
        surname: surname,
        phone: phone,
        email: email
      }, function (v) {
        return v && v !== '';
      });
      onSave(savingParams);
      this.setState({
        showErrors: true
      });
    }
  }, {
    key: "isChanged",
    value: function isChanged() {
      var _this2 = this;
      var fields = ['name', 'surname', 'phone', 'email'];
      var _this$state2 = this.state,
        email = _this$state2.email,
        phone = _this$state2.phone;
      var isFilled = email || phone;
      return isFilled && fields.some(function (fieldName) {
        return _this2.props[fieldName] !== _this2.state[fieldName];
      });
    }
  }, {
    key: "phoneFieldRenderer",
    value: function phoneFieldRenderer() {
      var phone = this.state.phone;
      var _this$props3 = this.props,
        callable = _this$props3.callable,
        isPartnerClient = _this$props3.isPartnerClient;
      var disabled = !callable || isPartnerClient;
      return phone && /*#__PURE__*/_react["default"].createElement(StyledPhoneButton, {
        onClick: this.handleCallClick,
        disabled: disabled
      }, /*#__PURE__*/_react["default"].createElement(StyledLabel, null, phone), /*#__PURE__*/_react["default"].createElement(StyledPhoneIcon, null));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state3 = this.state,
        stateEmail = _this$state3.email,
        isEmailEditable = _this$state3.isEmailEditable,
        isNameEditable = _this$state3.isNameEditable,
        isPhoneEditable = _this$state3.isPhoneEditable,
        isSurnameEditable = _this$state3.isSurnameEditable,
        stateName = _this$state3.name,
        statePhone = _this$state3.phone,
        showErrors = _this$state3.showErrors,
        stateSurname = _this$state3.surname;
      var _this$props4 = this.props,
        propName = _this$props4.name,
        propSurname = _this$props4.surname;
      var _this$props5 = this.props,
        active = _this$props5.active,
        avatarUrl = _this$props5.avatarUrl,
        email = _this$props5.email,
        errors = _this$props5.errors,
        id = _this$props5.id,
        isDeleted = _this$props5.isDeleted,
        isLoading = _this$props5.isLoading,
        isNew = _this$props5.isNew,
        isPartnerClient = _this$props5.isPartnerClient,
        messengers = _this$props5.messengers,
        name = _this$props5.name,
        ticketable = _this$props5.ticketable,
        props = (0, _objectWithoutProperties2["default"])(_this$props5, _excluded);
      var hasMessengers = messengers && !!messengers.length && !isPartnerClient;

      // Fixes test warnings.
      delete props.onCallClick;
      delete props.onMessengerClick;
      delete props.onSave;
      if (isLoading) {
        return /*#__PURE__*/_react["default"].createElement(StyledSkeleton, null);
      }
      return /*#__PURE__*/_react["default"].createElement(StyledClientCard, props, isDeleted && /*#__PURE__*/_react["default"].createElement(StyledDeactivatedWarn, null, "\u041A\u043B\u0438\u0435\u043D\u0442 \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D"), /*#__PURE__*/_react["default"].createElement(StyledAbout, null, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
        name: name,
        url: avatarUrl,
        pulsing: active
      }), /*#__PURE__*/_react["default"].createElement(StyledInfo, null, isNameEditable ? /*#__PURE__*/_react["default"].createElement(StyledBaseEditor, {
        error: showErrors && errors.name,
        name: "name",
        onChange: this.handleChangeField,
        onFocus: this.handleFocusField,
        onReset: this.handleResetField,
        onSave: this.handleSaveField,
        placeholder: "\u0418\u043C\u044F",
        preventClose: !isNew,
        validation: VALIDATION_RULES.NAME,
        value: stateName
      }) : /*#__PURE__*/_react["default"].createElement(StyledName, {
        name: propName
      }), isSurnameEditable ? /*#__PURE__*/_react["default"].createElement(StyledBaseEditor, {
        error: showErrors && errors.surname,
        name: "surname",
        onChange: this.handleChangeField,
        onFocus: this.handleFocusField,
        onReset: this.handleResetField,
        onSave: this.handleSaveField,
        placeholder: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F",
        preventClose: !isNew,
        validation: VALIDATION_RULES.SURNAME,
        value: stateSurname
      }) : /*#__PURE__*/_react["default"].createElement(StyledName, {
        name: propSurname
      }), id && /*#__PURE__*/_react["default"].createElement(StyledId, null, "#", id)), ticketable && /*#__PURE__*/_react["default"].createElement(_CreateTicketButton["default"], {
        onClick: this.handleNewTicketClick
      })), /*#__PURE__*/_react["default"].createElement(_EditableField["default"], {
        error: showErrors && errors.phone,
        label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        name: "phone",
        onChange: this.handleChangeField,
        onFocus: this.handleFocusField,
        onReset: this.handleResetField,
        onSave: this.handleSaveField,
        placeholder: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
        preventClose: !isNew,
        readOnly: !isPhoneEditable,
        validation: VALIDATION_RULES.PHONE,
        value: statePhone
      }, this.phoneFieldRenderer()), /*#__PURE__*/_react["default"].createElement(StyledEditableField, {
        error: showErrors && errors.email,
        label: "E-mail",
        name: "email",
        onChange: this.handleChangeField,
        onFocus: this.handleFocusField,
        onOpen: function onOpen(_ref5) {
          var value = _ref5.value;
          return _this3.handleMessengerClick({
            type: MessengerTypes.MAIL,
            value: value
          });
        },
        onReset: this.handleResetField,
        onSave: this.handleSaveField,
        placeholder: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043F\u043E\u0447\u0442\u0443",
        preventClose: !isNew,
        readOnly: !isEmailEditable,
        disabled: isPartnerClient,
        required: !!email,
        validation: VALIDATION_RULES.EMAIL,
        value: stateEmail
      }), hasMessengers && /*#__PURE__*/_react["default"].createElement(StyledField, null, /*#__PURE__*/_react["default"].createElement(StyleLabel, null, "\u0427\u0430\u0442\u044B"), /*#__PURE__*/_react["default"].createElement(StyledMessengers, null, messengers.map(function (type) {
        return /*#__PURE__*/_react["default"].createElement(StyledMessengerButton, {
          onClick: function onClick() {
            return _this3.handleMessengerClick({
              type: type
            });
          }
        }, /*#__PURE__*/_react["default"].createElement(_Messenger["default"], {
          type: type
        }));
      }))), isNew && /*#__PURE__*/_react["default"].createElement(StyledSubmitButton, {
        disabled: !this.isChanged(),
        onClick: this.handleSave
      }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430"));
    }
  }]);
}(_react["default"].PureComponent);
ClientCard.propTypes = {
  active: _propTypes["default"].bool,
  avatarUrl: _propTypes["default"].string,
  callable: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  email: _propTypes["default"].string,
  errors: _propTypes["default"].objectOf(_propTypes["default"].string.isRequired),
  forceEditable: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  isLoading: _propTypes["default"].bool,
  isNew: _propTypes["default"].bool,
  messengers: _propTypes["default"].arrayOf(_propTypes["default"].object),
  name: _propTypes["default"].string,
  onCallClick: _propTypes["default"].func,
  onFocusField: _propTypes["default"].func,
  onMessengerClick: _propTypes["default"].func,
  onNewTicketClick: _propTypes["default"].func,
  onSave: _propTypes["default"].func,
  phone: _propTypes["default"].string,
  surname: _propTypes["default"].string,
  ticketable: _propTypes["default"].bool
};
ClientCard.defaultProps = {
  active: false,
  avatarUrl: '',
  callable: true,
  className: '',
  email: null,
  errors: {},
  forceEditable: null,
  id: null,
  isLoading: true,
  isNew: true,
  messengers: null,
  name: null,
  onCallClick: Function.prototype,
  onFocusField: Function.prototype,
  onMessengerClick: Function.prototype,
  onNewTicketClick: Function.prototype,
  onSave: Function.prototype,
  phone: null,
  surname: null,
  ticketable: false
};
var StyledClientCard = _styledComponents["default"].div.withConfig({
  displayName: "ClientCard__StyledClientCard",
  componentId: "sc-1vex66g-0"
})(["min-width:250px;padding:10px;width:100%;"]);
var StyledDeactivatedWarn = _styledComponents["default"].div.withConfig({
  displayName: "ClientCard__StyledDeactivatedWarn",
  componentId: "sc-1vex66g-1"
})(["padding:10px;background:rgb(245,243,242);border-radius:4px;margin-bottom:10px;text-align:center;color:#cd5555;"]);
var StyledAbout = _styledComponents["default"].div.withConfig({
  displayName: "ClientCard__StyledAbout",
  componentId: "sc-1vex66g-2"
})(["display:flex;margin-bottom:12px;"]);
var StyledInfo = _styledComponents["default"].div.withConfig({
  displayName: "ClientCard__StyledInfo",
  componentId: "sc-1vex66g-3"
})(["display:flex;flex-direction:column;flex-grow:1;"]);
var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "ClientCard__StyledAvatar",
  componentId: "sc-1vex66g-4"
})(["flex-shrink:0;height:40px;margin:2px 9px 0 0;width:40px;z-index:0;"]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "ClientCard__StyledName",
  componentId: "sc-1vex66g-5"
})(["font-size:18px;"]);
var StyledId = _styledComponents["default"].div.withConfig({
  displayName: "ClientCard__StyledId",
  componentId: "sc-1vex66g-6"
})(["color:#919499;font-size:12px;margin:3px 0 -3px 0;"]);
var StyledField = _styledComponents["default"].div.withConfig({
  displayName: "ClientCard__StyledField",
  componentId: "sc-1vex66g-7"
})(["align-items:flex-start;display:flex;margin-bottom:5px;"]);
var StyledEditableField = (0, _styledComponents["default"])(_EditableField["default"]).withConfig({
  displayName: "ClientCard__StyledEditableField",
  componentId: "sc-1vex66g-8"
})(["height:25px;margin-bottom:5px;"]);
var StyledBaseEditor = (0, _styledComponents["default"])(_EditableField["default"]).withConfig({
  displayName: "ClientCard__StyledBaseEditor",
  componentId: "sc-1vex66g-9"
})(["height:22px;", "{font-size:18px;font-weight:bold;&::placeholder{color:#c2c5cc;font-weight:bold;}}", "{color:#c2c5cc;font-size:18px;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}", "{color:black;cursor:default;font-size:18px;font-weight:bold;text-decoration:none;}"], StyledInput, StyledPlaceholder, StyledValue);
var StyleLabel = _styledComponents["default"].div.withConfig({
  displayName: "ClientCard__StyleLabel",
  componentId: "sc-1vex66g-10"
})(["width:100px;margin-top:1px;font-size:14px;"]);
var StyledMessengers = _styledComponents["default"].div.withConfig({
  displayName: "ClientCard__StyledMessengers",
  componentId: "sc-1vex66g-11"
})(["flex:1;display:flex;flex-wrap:wrap;margin:0 0 -5px;"]);
var StyledMessengerButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ClientCard__StyledMessengerButton",
  componentId: "sc-1vex66g-12"
})(["padding:0;width:24px;height:auto;border:none;background:none;margin-right:6px;margin-bottom:5px;"]);
var StyledPhoneIcon = (0, _styledComponents["default"])(_iconsReact.PhoneOpen).withConfig({
  displayName: "ClientCard__StyledPhoneIcon",
  componentId: "sc-1vex66g-13"
})(["width:21px;height:15px;margin-left:6px;display:inline-block;vertical-align:middle;"]);
var StyledPhoneButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ClientCard__StyledPhoneButton",
  componentId: "sc-1vex66g-14"
})(["background:white;font-family:inherit;font-size:14px;height:36px;text-align:center;text-decoration:none;width:169px;&:hover{color:#007aff;border-color:#007aff;}&:disabled{pointer-events:none;user-select:all;svg path{stroke:#c2c5cc;}}"]);
var StyledSubmitButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ClientCard__StyledSubmitButton",
  componentId: "sc-1vex66g-15"
})(["width:100%;color:white;height:36px;border:none;font-size:13px;font-weight:bold;background-color:#007aff;&:hover{color:white;}&:disabled{background-color:#c2c5cc;}"]);
var StyledLabel = _styledComponents["default"].span.withConfig({
  displayName: "ClientCard__StyledLabel",
  componentId: "sc-1vex66g-16"
})(["height:17px;overflow:hidden;max-width:119px;white-space:nowrap;display:inline-block;vertical-align:middle;text-overflow:ellipsis;"]);
var StyledSkeleton = (0, _styledComponents["default"])(_ClientCardSkeleton["default"]).withConfig({
  displayName: "ClientCard__StyledSkeleton",
  componentId: "sc-1vex66g-17"
})(["height:157px;min-width:250px;padding:12px 10px;width:100%;"]);
var _default = exports["default"] = ClientCard;